import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { validateAllowDomains } from './validateAllowDomains';
import { validateDisallowDomains } from './validateDisallowDomains';

type DomainRestriction = {
  /** `,` 区切りの許可ドメイン。`*` は全許可、空文字は全拒否 */
  allowDomains: string;
  /** `,` 区切りの禁止ドメイン。`*` は全禁止、空文字は禁止なし */
  disallowDomains: string;
};

export function createEmailInputSchema({ allowDomains, disallowDomains }: DomainRestriction) {
  return z.object({
    email: z
      .string()
      .min(1, { message: 'メールアドレスの形式が正しくありません' })
      .email('メールアドレスの形式が正しくありません')
      .refine(
        (email) => {
          const [, domain] = email.split('@');
          // emailバリデーションを通っているので、emailの中に必ず@は入っていてsplitにより配列の要素は２つになる想定
          // 許可リストに含まれていることを確認した上で、禁止リストに含まれていることを確認する流れとしているため && でチェックを行う
          return validateAllowDomains(allowDomains, domain!) && validateDisallowDomains(disallowDomains, domain!);
        },
        {
          error: (issue) => `${String(issue.input).split('@')[1]} が含まれるメールアドレスはご利用いただけません`,
        }
      ),
  });
}

export type EmailInputType = z.infer<ReturnType<typeof createEmailInputSchema>>;

export function createEmailInputResolver(domainRestriction: DomainRestriction) {
  return zodResolver(createEmailInputSchema(domainRestriction));
}
